
// export default CategoriesLevel;
import React, { useEffect, useState } from "react";
import {
  fechCategoriesPerParents,
  fetchCategoryData,
} from "../Proucts/DataService";
import { Col, Form } from "react-bootstrap";

function CategoriesLevel({
  onCatParenteChange,
   onCatBasLevelChange,
  categorie,
  setCategorie,
  categorieParente,
  setCategorieParente,
}) {
  const [categories, setCategories] = useState([]);
  const [subCategorie, setSubCategorie] = useState([]);

  // Function to handle parent category selection
  const handleChoice = async (value) => {
    setCategorieParente(value);
    if (onCatParenteChange) onCatParenteChange(value);
    try {
      const response = await fechCategoriesPerParents(value);
      if (response) {
        setSubCategorie(response.data);
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  // Fetch categories on component mount
  const fetchCategories = async () => {
    try {
      const Catdata = await fetchCategoryData();
      setCategories(Catdata);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  // Recursive function to render category options
  const renderSelectOptions = (categories, level = 0) => {
    if (!Array.isArray(categories) || categories.length === 0) {
      return null;
    } 
    return categories.map((category) => (
      <React.Fragment key={category.id}>
        <option value={category.id}>
          {"--".repeat(level)} {category.name}
        </option>
        {category.subcategories &&
          category.subcategories.length > 0 &&
          renderSelectOptions(category.subcategories, level + 1)}
      </React.Fragment>
    ));
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <>
      {/* Parent Category Dropdown */}
      <Col md={3}>
        <Form.Group controlId="formCategorie">
          <Form.Label>Categorie Parente</Form.Label>
          <Form.Control
            value={categorieParente}
            onChange={(e) => handleChoice(e.target.value)}
            as="select"
            className="form-select"
          >
            <option value="">Sélectionner une catégorie</option>
            {renderSelectOptions(categories)}
          </Form.Control>
        </Form.Group>
      </Col>

      {/* Subcategory Dropdown */}
      <Col md={3}>
        <Form.Group controlId="formSubCategorie">
          <Form.Label>Categorie</Form.Label>
          <Form.Control
            value={categorie}
            as="select"
            className="form-select"
            onChange={(e) => {
              if (onCatBasLevelChange) onCatBasLevelChange(e.target.value);
              setCategorie(e.target.value);
            }}
          >
            <option value="">Sélectionner une sous-catégorie</option>
            {renderSelectOptions(subCategorie)}
          </Form.Control>
        </Form.Group>
      </Col>
    </>
  );
}

export default CategoriesLevel;
